import script from "./ChatThread.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatThread.vue?vue&type=script&setup=true&lang=js"

import "./ChatThread.vue?vue&type=style&index=0&id=358d7189&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358d7189"]])

export default __exports__